import React from 'react';
import PropTypes from 'prop-types';


const Text = ({ text, style }) => (
  <div
    className={style === 'regular' ? 'template__maintext' : 'template__textblock'}
    dangerouslySetInnerHTML={{
      __html: text.html,
    }}
  />
);

Text.propTypes = {
  text: PropTypes.shape({ html: PropTypes.string.isRequired }).isRequired,
  style: PropTypes.oneOf(['regular', 'full width with borders']).isRequired,
};

export default Text;

export const query = graphql`
  fragment TextFragment on PrismicCaseStudyBodyText {
    slice_type
    primary {
      text {
        html
      }
      style
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/CaseStudy/Text/Text.js